import styled from 'styled-components';

import { Button } from 'components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background-color: ${(props) => props.theme.color.greyLight_1};
  justify-content: center;
  align-items: center;

  ${Button} {
    width: 340px;
    margin-top: 32px;
  }
`;
